import React from 'react';
import { AuthContext } from '@/contexts/AuthContext';
import { User } from 'firebase/auth';

// Create a mock User object that implements the Firebase User interface
const mockUser: User = {
  uid: 'example-data',
  email: 'example@example.com',
  emailVerified: true,
  isAnonymous: false,
  metadata: {},
  providerData: [],
  refreshToken: '',
  tenantId: null,
  delete: async () => {},
  getIdToken: async () => '',
  getIdTokenResult: async () => ({
    token: '',
    signInProvider: null,
    claims: {},
    authTime: '',
    issuedAtTime: '',
    expirationTime: '',
  }),
  reload: async () => {},
  toJSON: () => ({}),
  displayName: null,
  phoneNumber: null,
  photoURL: null,
  providerId: 'password'
};

export const ExampleAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Implement all required AuthContextType properties
  const authValue = {
    currentUser: mockUser,
    loading: false,
    signUp: async () => { throw new Error('Not implemented in example mode'); },
    signIn: async () => { throw new Error('Not implemented in example mode'); },
    logout: async () => { throw new Error('Not implemented in example mode'); }
  };

  return (
    <AuthContext.Provider value={authValue}>
      {children}
    </AuthContext.Provider>
  );
};